export const KICKOFF_YARDLINE = 35;
export const TOUCHBACK_YARDLINE = 25;
export const NON_KICKOFF_TOUCHBACK_YARDLINE = 20;
export const FIRST_DOWN_YARDAGE = 10;
export const PAT_YARDLINE = 3;
export const SAFTEY_KICKOFF_YARDLINE = 20;
